import type { BadgeTone } from '@skupreme/shared/ui';

/** EN-4134: the connection status (connections-db: active, paused_credential, paused_provider, disabled) in words. */
const STATUSES: Record<string, { label: string; tone: BadgeTone }> = {
  active: { label: 'Active', tone: 'success' },
  paused_credential: { label: 'Paused: credential', tone: 'warning' },
  paused_provider: { label: 'Paused by provider', tone: 'warning' },
  disabled: { label: 'Inactive', tone: 'neutral' },
};

export const providerStatus = (status: string) =>
  STATUSES[status] ?? {
    label: status.replace(/_/g, ' ').replace(/^./, c => c.toUpperCase()),
    tone: 'neutral' as BadgeTone,
  };

/** EN-4134: how long ago, as the prototype's status line reads it: "just now", "12m ago", "3h ago", "2d ago". */
export const timeAgo = (iso: string | null | undefined, now = Date.now()) => {
  if (!iso) return null;
  const minutes = Math.floor((now - new Date(iso).getTime()) / 60_000);
  if (!Number.isFinite(minutes)) return null;
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};
